namespace Ir.Components.Workbook.Settings.RichTextSettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<SettingTabVM>;
        itemConfig: BaseItemConfig;

        editButtonConfig: DevExpress.ui.dxButton.Properties;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        let self = this;
        this.config = params.config as WorkbookConfig;
        this.activeTabOrWidget = params.activeTabOrWidget;
        this.activeTabItem = params.activeTabItem;
        
        this.itemConfig = this.activeTabOrWidget().itemConfig();
        let dashboardWidget = this.activeTabOrWidget() as DashboardWidget;
        let config = this.itemConfig as RichTextConfig;
        let widget = this.activeTabOrWidget().widget.getWidget<RichTextWidget>() as RichTextWidget;

        this.editButtonConfig = {
            text: "Edit",
            icon: "edit",
            width: "100%",
            onClick() {
                let backgroundColor = dashboardWidget.appearance.backgroundColorUI();
                if (!dashboardWidget.appearance.backgroundColorUI() || dashboardWidget.appearance.backgroundColorUI().toLowerCase() === "transparent") {
                    backgroundColor = dashboardWidget.dashboard.appearance.backgroundColor();
                }

                let filters = getFilters();
                let metrics = getMetrics();
                Ir.Components.Workbook.Settings.Items.HtmlEditorSetting.show({
                    value: widget.result.htmlText,
                    backgroundColor: backgroundColor,
                    onSaving(value: string, height: number) {
                        let result = widget.convertHtml(value);
                        if (result.success) {
                            config.htmlText(result.value);
                        }
                        return result.success;
                    },
                    useMetrics: true,
                    useFilters: true,
                    getFilters,
                    menuOptions: [{
                        name: 'Metrics',
                        icon: "ms ir-functions-icon",
                        items: metrics,
                        visible: ko.computed(function () { return metrics.length > 0; })
                    },
                    {
                        name: 'Filters',
                        icon: "ms ir-filter_alt-icon",
                        items: filters,
                        visible: ko.computed(function () { return filters.length > 0; })
                    }],
                    linkButton: { 
                        widget: 'dxButton',
                        options: {
                            hint: 'Link to open external workbook',
                            icon: 'ms ir-add-link',
                            text: 'Workbook',
                            stylingMode: 'text',
                            onClick() {
                                let itemSelected = null;
                                let textSelected = null;
                                let customLink = Ir.Components.Workbook.Settings.Items.HtmlEditorSetting.getCustomLink();
                                if (customLink) {
                                    let id = parseInt(customLink.link.match(/-?\d+/g)[0]);
                                    itemSelected = customLink.link.includes("W") ? `workbook-${id}` : `tab-${id}`;
                                    textSelected = customLink.text;
                                }

                                Ir.Components.Workbook.Settings.Items.LinkWorkbooksTabsSetting.show({
                                    richConfig: config,
                                    itemSelected: itemSelected,
                                    textSelected: textSelected,
                                    rangeSelected: customLink?.range
                                } as Ir.Components.Workbook.Settings.Items.LinkWorkbooksTabsSetting.IParamsConfig);
                            },
                        }
                    }
                } as Ir.Components.Workbook.Settings.Items.HtmlEditorSetting.IHtmlEditorSettings);
            }
        };
    }

    function getMetrics() {
        let metrics: Array<VariableRichText> = [];
        let mapping = MappingService.getCurrentMapping();
        for (let metric of mapping.visibleMetrics) {
            metrics.push(new VariableRichText(VariableTypeEnum.Metric, metric.displayName));
        }

        return metrics;
    }

    function getFilters() {
        let filters: Array<VariableRichText> = [];
        for (let filter of workbook.workbookConfig.filters()) {
            filters.push(new VariableRichText(VariableTypeEnum.Filter, filter.filterName(), filter.filterEditorType(),
                filter.isMetric() ? VariableFilterTypeEnum.Metric : VariableFilterTypeEnum.Default));
        }

        for (let filter of workbook.workbookConfig.activeTab().filters()) {
            //const filterType = filter.isMetric() ? VariableFilterTypeEnum.Metric : filter.showFilter() ? VariableFilterTypeEnum.Default : VariableFilterTypeEnum.Widget
            const filterType = filter.isMetric() ? VariableFilterTypeEnum.Metric : VariableFilterTypeEnum.Default;
            if (filters.filter(x => x.name === filter.filterName() && x.filterType === filterType).length === 0) {
                filters.push(new VariableRichText(VariableTypeEnum.Filter, filter.filterName(), filter.filterEditorType(), filterType));
            }
        }

        if (workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard) {
            for (let widgetFilter of workbook.workbookConfig.activeTab().dashboard.widgets().filter(x => x.widgetType() === WidgetType.Filter)) {
                const filterConfig = widgetFilter.itemConfig() as FilterConfig;
                const filterName = filterConfig.filterName;
                if (filters.filter(x => x.name === filterName && x.filterType === VariableFilterTypeEnum.Default).length === 0) {
                    filters.push(new VariableRichText(VariableTypeEnum.Filter, filterName, filterConfig.filterEditorType, VariableFilterTypeEnum.Default));
                }
            }
        }

        if (workbook.workbookConfig.activeTabOrWidget().tabOrWidget === TabOrWidgetEnum.Widget) {
            for (let filter of workbook.workbookConfig.activeTabOrWidget().filters()) {
                const filterType = filter.isMetric() ? VariableFilterTypeEnum.Metric : VariableFilterTypeEnum.Default
                if (filters.filter(x => x.name === filter.filterName() && x.filterType === filterType).length === 0) {
                    filters.push(new VariableRichText(VariableTypeEnum.Filter, filter.filterName(), filter.filterEditorType(), filterType));
                }
            }
        }

        let filterVariables = getFilterVariables();
        for (let filter of filters) {
            if (filter.filterEditorType === FilterEditorTypeEnum.Date || filter.filterEditorType === FilterEditorTypeEnum.DateRange) {
                let isDateRange = filter.filterEditorType === FilterEditorTypeEnum.DateRange;
                for (let variable of filterVariables) {
                    if (variable.range === isDateRange || variable.range === undefined) {
                        filter.items.push(new VariableRichText(VariableTypeEnum.Filter, filter.name, filter.filterEditorType, filter.filterType, variable));
                    }
                }
            }
        }

        return filters;
    }
}